module.exports = __webpack_public_path__ + "img/em13.2f6d7748.jpg";